import { render, staticRenderFns } from "./SSwitchAccordion.vue?vue&type=template&id=2ad3e082&lang=pug"
import script from "./SSwitchAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./SSwitchAccordion.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SSwitchAccordion.vue?vue&type=style&index=0&id=2ad3e082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports